import React from "react";
import {Quote} from "./Quote/Quote";

export const Home = () => {
    return <Quote />
};
